import { createContext, useContext } from 'react';

export interface SnippetFiltersState {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
}

export const SnippetFiltersContext = createContext<SnippetFiltersState>({
  searchQuery: '',
  setSearchQuery: () => undefined,
});

export const useSnippetFiltersContext = () => useContext(SnippetFiltersContext);
